<template>
  <div class="inquiry-list-page inquiry-guide-page">
    <!-- result -->
    <div class="result-wrapper">
      <h4 class="title">1. 标题？？？</h4>
      <img :src="guideUrl" style="width: 100%;" />
      <h4 class="title">2. 合同保理（核心企业确权）</h4>
      <img :src="guideUrl1" style="width: 100%;" />
    </div>
  </div>
</template>

<script>
import mixin from "@/mixins//list";
import OrderCard from "@/components/OrderCard/Card2";

export default {
  mixins: [mixin],
  components: {
    card: OrderCard
  },
  data() {
    return {};
  },
  computed: {
    guideUrl() {
      return `${process.env.BASE_URL || "./"}file/apply_guide.png`;
    },
    guideUrl1() {
      return `${process.env.BASE_URL || "./"}file/apply_guide_2.png`;
    }
  },
  created() {}
};
</script>

<style lang="scss">
  .inquiry-guide-page {
    .title {
      padding: 20px;
      color: #666;
      background: #fff;
    }
  }
</style>